import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {School} from 'mdi-material-ui';
export default function Education(){
    return(
        <div>
            <Typography component="div">
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    <School color="primary" style={{ fontSize: 40 }} />
                    <Box fontWeight="bold" fontSize={40} m={2}>
                        education
                    </Box>
                </div>
            </Typography>
            <div style={{display:"flex",flexWrap:"wrap",padding:10}}>
                <div style={{width:130}}>
                    <Box fontSize={16} m={1} fontWeight="bold" textAlign="justify" style={{color:'#a8a8a8'}}>
                    2015-PRESENT 
                    </Box>
                </div>
                <div>
                    <Box fontSize={16} m={1} fontWeight="bold" textAlign="justify">
                    Bachelors of Computer Engineering 
                    </Box>
                    <Box fontSize={14} m={1} textAlign="justify">
                    K. N. Toosi University of Technology, Tehran, Iran
                    </Box>
                    <Box fontSize={14} m={1}  style={{color:'#a8a8a8'}} textAlign="justify">
                    <a href="https://www.timeshighereducation.com/world-university-rankings/kn-toosi-university-technology" rel="noopener noreferrer" target="_blank">World University Rankings 2020</a>:  801–1000<sup>th</sup> 
                    </Box>
                    <Box fontSize={14} m={1} fontWeight="bold"  textAlign="justify">
                    GPA: 3.73/4.00 (17.55/20.00)
                    </Box>
                    <Box fontSize={14} m={1} fontWeight="bold"  textAlign="justify">
                    Last Two years GPA: 3.98/4.00 (18.53/20.00)
                    </Box>
                </div>
            </div>
            <div style={{display:"flex",flexWrap:"wrap",padding:10}}>
                <div style={{width:130}}>
                    <Box fontSize={16} m={1} fontWeight="bold" textAlign="justify" style={{color:'#a8a8a8'}}>
                    2012-2015 
                    </Box>
                </div>
                <div>
                    <Box fontSize={14} m={1} fontWeight="bold" textAlign="justify">
                    Hedayat High School, Tehran, Iran
                    </Box>
                </div>
            </div>
            <Typography component="div">
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    <Box fontWeight="bold" fontSize={20} >
                    relevant coursework
                    </Box>
                </div>
            </Typography>
            <Box fontSize={16}  style={{color:'#a8a8a8'}} textAlign="justify">
                <ul>
                    <li>Foundation of Computer Vision (A+)</li> 
                    <li>Fundamentals of Robotics (A+)</li>
                    <li>Artificial Intelligence and Expert Systems (A)</li>
                    <li>Algorithm Design (A+)</li>
                    <li>Graph Theory and Algorithms (A+)</li>
                    <li>Numerical Methods (A+)</li>
                    <li>Embedded and Real-Time Systems (A+)</li>
                </ul> 
            </Box>
            <Typography component="div">
                <div style={{ display: "flex", alignItems: "center", marginLeft: 10 }}>
                    <Box fontWeight="bold" fontSize={20} >
                    research interests
                    </Box>
                </div>
            </Typography>
            <Box fontSize={16}  style={{color:'#a8a8a8'}} textAlign="justify">
                <ul>
                    <li>Reinforcement Learning</li> 
                    <li>Computer Vision</li>
                    <li>Generative Adversarial Networks</li>
                    <li>Robotics</li>
                    <li>Computational Geometry</li>
                </ul> 
            </Box>
        </div>
    )
}
